import { jwtDecode } from 'jwt-decode';
import { authOfflineService } from '../auth-offline.service.js';

const STORAGE_KEYS = {
  TOKEN: 'accessToken',
  THEME: 'theme',
};

// Token management
export const getToken = () => localStorage.getItem(STORAGE_KEYS.TOKEN);
export const setToken = (token) => localStorage.setItem(STORAGE_KEYS.TOKEN, token);
export const removeToken = (force = false) => {
  try {
    if (force || !authOfflineService.isOfflineGraceValid()) {
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
    } else {
      // Keep the token during the offline grace period to allow offline usage
      console.warn('[Storage] Skipping token removal due to active offline grace');
    }
  } catch (e) {
    // ignore
  }
};

export const getTokenPayload = () => {
  const token = getToken();
  if (!token) return null;

  try {
    return jwtDecode(token);
  } catch {
    removeToken();
    return null;
  }
};

/** User profile fields from the JWT (same source as AuthContext). */
export const getUser = () => {
  const decoded = getTokenPayload();
  if (!decoded) return null;

  if (decoded.exp * 1000 < Date.now()) {
    if (authOfflineService.isOfflineGraceValid()) {
      return decoded;
    }

    removeToken();
    return null;
  }

  return decoded;
};

export const setUser = () => {
  // User is derived from accessToken; persist token via setToken instead.
};

export const removeUser = () => {
  removeToken();
};

export const clearStorage = () => {
  removeToken();
};

// Theme management
export const getTheme = () => localStorage.getItem(STORAGE_KEYS.THEME);
export const setTheme = (theme) =>
  localStorage.setItem(STORAGE_KEYS.THEME, theme);
